import { useMemo } from "react";
import { ScheduleType } from "@common/types/domains/accounting/schedule";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { buildScheduleHubUrl } from "@components/accounting/schedulesReport/schedulesReportDrillDown.lib";

/**
 * Opens the Schedules tab on one applied schedule. Undefined until the cell
 * has an application to open.
 */
export function useOpenScheduleJournalEntries(
    schedule: {
        templateId?: string | null;
        scheduleApplicationId: string;
        scheduleType?: ScheduleType;
    } | null,
): (() => void) | undefined {
    const navigate = useStateAwareNavigate();
    const templateId = schedule?.templateId;
    const scheduleApplicationId = schedule?.scheduleApplicationId;
    const scheduleType = schedule?.scheduleType;

    return useMemo(() => {
        if (!scheduleApplicationId) {
            return undefined;
        }
        return () =>
            navigate(
                buildScheduleHubUrl({
                    templateId: templateId ?? undefined,
                    scheduleApplicationId,
                    scheduleType,
                }),
            );
    }, [navigate, scheduleApplicationId, scheduleType, templateId]);
}
